// extracted by mini-css-extract-plugin
export var footer = "_oy-0";
export var inherit = "_oy-1";
export var input = "_oy-2";
export var modalContent = "_oy-3";
export var quillEditor = "_oy-4";
export var subtitle = "_oy-5";